// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__GZsF1","insightsList":"newBusinessInsightsMenu_insightsList__2jVEF","active":"newBusinessInsightsMenu_active__ecO22"};